var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('vs-chip',{class:_vm.statusModifier.label + ' text-white'},[_vm._v(" "+_vm._s(_vm.statusModifier.text)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }